import React from "react";
import { bool } from "prop-types";
import { Button } from "react-bootstrap";

const HelpCenterSection = (props) => {
  const { isAU } = props;

  const handleOpenHelpCenter = () => {
    const url = isAU
      ? "https://criteriacorp.helpdocs.io/category/qg9ubd74nb-how-to-guides"
      : "https://criteria.helpdocs.io/category/j204q0726l-how-to-guides";

    window.open(url, "_blank");
  };

  return (
    <div className="help-center-section">
      <p className="mb-2">
        Get help with features and answer to your questions. Search our Help
        Center.
      </p>
      <Button
        variant="primary"
        className="text-center w-100"
        onClick={handleOpenHelpCenter}
      >
        Help Center
      </Button>
    </div>
  );
};

HelpCenterSection.propTypes = {
  isAU: bool,
};

export default HelpCenterSection;
